import i18n from 'src/i18n';
import RangeColorInfo from 'src/views/Pages/Dashboard/RangeColor/RangeColorInfo.vue';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            minWidth: 150,
            sortable: true
        },
        {
            prop: 'name',
            label: i18n.t('common_words.color_range_details'),
            minWidth: 260,
            formatter: RangeColorInfo,
            sortable: true
        },
    ];

    return { tableColumns };
};

export default configTable;
